var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar13 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 33,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BEBEBE",
  d: "M16.049.927c.3-.921 1.603-.921 1.902 0l3.315 10.202a1 1 0 0 0 .95.69h10.727c.97 0 1.372 1.24.588 1.81l-8.678 6.305a1 1 0 0 0-.363 1.118l3.315 10.201c.299.922-.756 1.688-1.54 1.118l-8.677-6.305a1 1 0 0 0-1.176 0l-8.678 6.305c-.784.57-1.838-.196-1.539-1.118L9.51 21.052a1 1 0 0 0-.363-1.118L.469 13.629c-.784-.57-.381-1.81.588-1.81h10.726a1 1 0 0 0 .951-.69z"
})));
export default SvgStar13;